export default __webpack_public_path__ + "m_bg28798ea.png";